import { Injectable } from '@angular/core';
import { NotificationsTrayService } from './notifications-tray/notifications-tray.service';
import { NotificationMessage } from './notifications.model';
import { ToastNotificationsService } from './toast-notifications/toast-notifications.service';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  constructor(
    private notificationsTrayService: NotificationsTrayService,
    private toastNotificationsService: ToastNotificationsService
  ) {}

  public notify(n: any): void {
    const message: NotificationMessage = {
      title: n.Title,
      description: n.Description,
      id: n.id,
      userName: n.UserName,
      moduleName: n.ModuleName,
      creationDate: n.CreationDate,
      path: n.Path,
      status: n.Status
    };

    if (!this.notificationsTrayService.isActive()) {
      this.toastNotificationsService.addNotification(
        Object.create(message) as NotificationMessage
      );
    }

    this.notificationsTrayService.addNotification(
      Object.create(message) as NotificationMessage
    );
  }
}
